<script>
import axios from 'axios';
import paginationMixin from '@/mixins/pagination';
import snackbarMixin from '@/mixins/snackbar';
import RbxFileUpload from '@/shared/reybex/RbxFileUpload';
import mainViewTabMixin from '@/mixins/mainViewTab';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';
import ClientHistoryListItem from './ClientHistoryListItem';

export default {
  name: 'ClientHistory',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
    RbxFileUpload,
    ClientHistoryListItem,
  },
  mixins: [mainViewTabMixin, paginationMixin, fieldVisibilityMixin, snackbarMixin],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'company',
      clientHistoryList: {},
      headers: [{ text: 'Modul', value: 'className' }, { text: 'Feld', value: 'propertyName' },
        { text: 'Alter Wert', value: 'oldValue' }, { text: 'Neuer Wert', value: 'newValue' },
        { text: 'Geändert von', value: 'user' }, { text: 'Geändert am', value: 'lastUpdated' }],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get(`/client/history/${this.clientId}`)
        .then((history) => {
          console.log('history', history);
          this.clientHistoryList = history;
          // if (!this.clientHistoryList) this.clientHistoryList = [];
          // history.data.forEach((it) => {return this.clientHistoryList.push(it)});
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<template>
  <div class="company-list">
    <!-- Basic information left column -->
    <v-toolbar dark dense height="40" color="blue-grey lighten-2"/>
    <template>
      <v-data-table
        :headers="headers"
        :items="clientHistoryList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <client-history-list-item :history="props.item" :expanded="props.expanded"/>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>
  </div>
</template>
